import React from 'react'
import { CircularProgress } from '@material-ui/core'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60vh;
`

const Loader = () => (
  <Container>
    <CircularProgress />
  </Container>
)

export default Loader
